import { BaseModel } from "../../../service/models/base";
import {
  AddressModel,
  addressDefaultValue,
} from "../../accounts/models/party_model";

export interface WarehouseGroupModel extends BaseModel {
  name: string;
  description?: String;
}
export const WAREHOUSE_TYPE = {
  internal: "internal",
  external: "external",
};

// Single warehouse category dropdown (stored as sub_level). The warehouse
// `type` is derived from it: only Manpower is external, everything else internal.
export const WAREHOUSE_SUB_LEVEL_OPTIONS = [
  "Manpower",
  "Job Work",
  "RWA",
  "Infra",
  "Kazam Warehouse",
  "Lab",
];

export const subLevelToType = (
  sub_level?: string,
): "internal" | "external" =>
  sub_level === "Manpower" ? "external" : "internal";

export interface SpocModel {
  uid?: string;
  contact_name: string;
  contact_mobile?: string;
  contact_email?: string;
  department?: string;
}
export const spocDefaultValue: SpocModel = {
  uid: "",
  contact_name: "",
  contact_mobile: "",
  contact_email: "",
};

export interface WarehouseModel extends BaseModel {
  name: string;
  type: "internal" | "external";
  sub_type?:
    | ("kazam warehouse" | "city engineer warehouse")
    | ("manpower" | "vendor");
  level?: string;
  sub_level?: string;
  vendor_code?: string;
  phone_number?: number;
  description?: string;
  address?: AddressModel;
}

export const warehouseDefaultValue: WarehouseModel = {
  name: "",
  type: "internal",
  address: addressDefaultValue,
};
